<template>
  <v-card-actions>
    <v-btn text
      v-if="getType === 'list'"
      color="secondary"
      @click="close">閉じる</v-btn>
    <v-btn text
      v-if="getType === 'detail'"
      color="secondary"
      @click="open({ type: 'list' })"><v-icon small class="mr-2">fal fa-angle-left</v-icon>戻る</v-btn>
    <v-spacer></v-spacer>
    <v-btn outlined
    v-if="getType === 'detail' && !getClientId"
    color="secondary"
    @click="open({ type: 'client' })"><v-icon small class="mr-2">fal fa-user-plus</v-icon>顧客を追加する</v-btn>
    <v-btn outlined
      v-if="getType === 'list'"
      color="secondary"
      class="mr-2"
      @click="open({ type: 'detail' })"><v-icon small class="mr-2">fal fa-plus</v-icon>追加する</v-btn>
    <v-btn depressed
      v-if="getType === 'list'"
      color="secondary"
      :disabled="!isSubmittable"
      :loading="isLoading"
      @click="submit"><v-icon small class="mr-2">fal fa-hands-usd</v-icon>振分ける</v-btn>
    <v-btn outlined
      v-if="getType === 'detail' && getClientId"
      color="secondary"
      class="mr-2"
      :disabled="!isValid && isSearching"
      @click="insert({ isSeries: true })"><v-icon small class="mr-2">fal fa-layer-plus</v-icon>続けて追加する</v-btn>
    <v-btn depressed
      v-if="getType === 'detail' && getClientId"
      color="secondary"
      :disabled="!isValid && isSearching"
      @click="insert">
      <v-icon small class="mr-2">{{ getFormId ? 'fal fa-sync' : 'fal fa-plus-square' }}</v-icon>{{ getFormId ? '更新する' : '追加する' }}
    </v-btn>
    <ClientInserter
      ref="clientInserter"
    />
  </v-card-actions>
</template>

<script>
import ClientInserter from '@/pages/author/pages/clients/modals/insert'
export default {
  name: 'authorAccountantEditorLayoutClientsActions',
  props: [ 'fid', 'cid', 'type', 'valid', 'status', 'submittable' ],
  components: {
    ClientInserter
  },
  methods: {
    insert: function (req) {
      this.$emit('emit', {
        action: 'insert',
        data: req
      })
    },
    submit: function () {
      this.$emit('submit')
    },
    open: function (req) {
      const { type } = req || {}
      if (type === 'client') {
        this.$refs.clientInserter.open()
      } else {
        this.$emit('open', req)
      }
    },
    close: function () {
      this.$emit('close')
    }
  },
  computed: {
    isValid () {
      return this.$props.valid
    },
    isLoading () {
      return this.$props.status && this.$props.status.loading
    },
    isSearching () {
      return this.$props.status && this.$props.status.searching
    },
    isSubmittable () {
      return this.$props.submittable
    },
    getFormId () {
      return this.$props.fid || ''
    },
    getClientId () {
      return this.$props.cid || ''
    },
    getType () {
      return this.$props.type || ''
    }
  }
}
</script>